const events = require("./impersonationEvents.js");

const impersonationHandlers = {
    [events.Transitioning.Name](prev, event) {
        const update = {
            ImpersonationTransition: {
                InProgress: true,
                TypeName: event.TransitionTypeName,
                Error: null
            }
        };

        return Object.assign({}, prev, update);
    },
    [events.Transitioned.Name](prev) {
        const update = {
            ImpersonationTransition: {
                InProgress: false,
                TypeName: "",
                Error: null
            }
        };

        return Object.assign({}, prev, update);
    },
    [events.TransitionErrored.Name](prev, event) {
        const update = {
            ImpersonationTransition: {
                InProgress: false,
                TypeName: "",
                Error: event.Error
            }
        };

        return Object.assign({}, prev, update);
    }
};

module.exports = impersonationHandlers;


// WEBPACK FOOTER //
// ./src/events/impersonation/impersonationHandlers.js